module.exports = __webpack_public_path__ + "static/media/mini.1d2b58ff.png";